export enum LinkType {
  PRIMARY,
  GHOST,
}

export enum AttachedLinkOptions {
  REMOTE_LINK,
  FILE,
}

export enum CoverImageAttachedOptions {
  DEFAULT,
  CUSTOMISED,
}
